import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api";

export function useQueryChgManufacturers(partnerId?: number | null) {
  return useQuery({
    queryKey: ["chg-manufacturers", partnerId],
    queryFn: async () => {
      const response = await apiClient.partnersChgManufacturersList(partnerId!);
      if (!response.ok) {
        throw new Error("Failed to fetch CHG manufacturers");
      }
      return response.data;
    },
    enabled: partnerId != null,
    retry: false,
  });
}
